(() => {
  const root = document.querySelector('[data-song-jin-home]');
  if (!root) return;

  const modal = root.querySelector('[data-sj-custom-modal]');
  const preview = root.querySelector('[data-sj-preview-image]');
  const variantId = root.querySelector('[data-sj-variant-id]');
  const customPrice = root.querySelector('[data-sj-custom-price]');
  const customForm = root.querySelector('[data-sj-custom-form]');
  const pieceOptions = [...root.querySelectorAll('[data-sj-piece-option]')];
  const shapeOptions = [...root.querySelectorAll('[data-sj-shape-option]')];
  const detailGroups = [...root.querySelectorAll('[data-sj-detail-group]')];
  let lastTrigger = null;

  const checkedOption = (options) => options.find((option) => option.querySelector('input')?.checked);

  const syncCustomizer = () => {
    if (!customForm) return;

    const piece = checkedOption(pieceOptions)?.dataset.piece || 'brooch';
    let activeShapes = [];

    shapeOptions.forEach((option) => {
      const active = option.dataset.piece === piece;
      const input = option.querySelector('input');
      option.hidden = !active;
      if (input) input.disabled = !active;
      if (active) activeShapes.push(option);
    });

    let shape = checkedOption(activeShapes);
    if (!shape && activeShapes.length) {
      shape = activeShapes[0];
      const input = shape.querySelector('input');
      if (input) input.checked = true;
    }

    detailGroups.forEach((group) => {
      const pieces = (group.dataset.pieces || '').split(',');
      const active = pieces.includes(piece);
      group.hidden = !active;
      group.querySelectorAll('input').forEach((input) => {
        input.disabled = !active;
      });
    });

    if (!shape) return;
    const imageUrl = shape.dataset.image;

    if (preview && imageUrl) preview.src = imageUrl;
    if (variantId && shape.dataset.variantId) variantId.value = shape.dataset.variantId;
    if (customPrice && shape.dataset.variantPrice) customPrice.textContent = shape.dataset.variantPrice;

  };

  const openModal = (trigger) => {
    if (!modal) return;
    lastTrigger = trigger;
    syncCustomizer();
    modal.hidden = false;
    document.body.classList.add('sj-modal-open');
    window.requestAnimationFrame(() => modal.querySelector('[data-sj-custom-close]')?.focus());
  };

  const closeModal = () => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('sj-modal-open');
    lastTrigger?.focus();
  };

  root.querySelectorAll('[data-sj-custom-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => openModal(trigger));
  });

  root.querySelectorAll('[data-sj-custom-close]').forEach((trigger) => {
    trigger.addEventListener('click', closeModal);
  });

  customForm?.addEventListener('change', syncCustomizer);
  syncCustomizer();

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
  });
})();

